<script setup lang="ts">
import { definePage } from "unplugin-vue-router/runtime";
import PracticeStaffAddEditForm from "@/components/models/practice/forms/PracticeStaffAddEditForm.vue";
import { useAbility } from "@casl/vue";

definePage({
  meta: {
    title: "generic.action.addEntity",
    titleParams: { entity: "generic.entity.staff" },
    checkPrivileges: () => {
      const { can } = useAbility();
      return can($permActions.CREATE, $permSubjects.PRACTICE__PRACTICESTAFF);
    },
  },
});
</script>

<template>
  <v-skeleton-loader>
    <PracticeStaffAddEditForm />
  </v-skeleton-loader>
</template>
